/* Restora draft — behaviour. Everything here has a Liquid/Horizon equivalent
   noted in README.md (nav drawer, sticky ATC, gallery, chooser, cart bubble). */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const D = window.RESTORA;
  /* Disabled products keep their data (existing carts, easy re-enable) but never render or sell.
     Markup that only makes sense with two or more masks carries data-needs-products; markup
     about one specific mask carries data-product="slug". Both are hidden here, not deleted. */
  D.allProducts = D.products;
  D.products = D.products.filter(p => !p.disabled);
  if (D.products.length < 2) $$('[data-needs-products]').forEach(el => { el.hidden = true; });
  else $$('[data-single-product]').forEach(el => { el.hidden = true; });   // single-mask wording, shown only while one mask is sold
  D.allProducts.filter(p => p.disabled).forEach(p => $$(`[data-product="${p.slug}"]`).forEach(el => { el.hidden = true; }));
  /* A line of product copy may point at another mask: { t:'...', more:' ... Sleep is the mask for that', needs:'sleep' }.
     The pointer is only shown while that mask is listed. */
  const xr = v => (v && v.t !== undefined) ? v.t + (D.products.some(x => x.slug === v.needs) ? (v.more || '') : '') : v;

  /* Images. Shopify's CDN resizes any theme image on request (&width=N) and serves WebP/AVIF by itself, so the theme keeps
     one full-size file per photo and every slot asks for the size it actually shows. A phone used to download the 1600px
     gallery photo (300 KB) for a 330px slot, and again for each 74px thumbnail. In the draft there is no CDN: file as is.
     The phone `sizes` values are under-declared on purpose (~72vw for a ~92vw slot) so a 3x screen settles for about 2.3x:
     no visible difference, a third fewer bytes. Every slot has an explicit CSS width, so `sizes` cannot affect layout. */
  const onCdn = u => !!(D.live && u && u.indexOf('/cdn/') > -1);
  const sized = (u, w) => onCdn(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u;
  const pic = (u, ws, sizes) => onCdn(u)
    ? `src="${sized(u, ws[Math.min(2, ws.length - 1)])}" srcset="${ws.map(w => sized(u, w) + ' ' + w + 'w').join(', ')}" sizes="${sizes}"`
    : `src="${u}"`;
  const W_MAIN = [480, 640, 800, 1000, 1200], S_MAIN = '(max-width: 960px) 72vw, 560px';   /* keep in step with snippets/rs-preload.liquid (port.py writes it) */
  const W_CARD = [320, 480, 640, 800],        S_CARD = '(max-width: 700px) 72vw, 380px';
  const W_FEAT = [400, 560, 720, 880, 1080],  S_FEAT = '(max-width: 960px) 72vw, 600px';
  const money = n => '$' + n.toFixed(2);
  const stars = n => '★★★★★'.slice(0, Math.round(n)) + '☆☆☆☆☆'.slice(0, 5 - Math.round(n));
  const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const ARROW = '<svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>';

  /* QA hook (draft only): ?qa=1 shows everything with no reveal animation */
  if (new URLSearchParams(location.search).has('qa')) document.documentElement.classList.add('qa');

  /* Hero image panel ---------------------------------------------------- */
  /* Three model shots, one per mask, crossfading. In Liquid this is a repeating
     block on rs-hero.liquid: image + label per block, same markup and script. */
  const heroEl = $('[data-hero]');
  if (heroEl) {
    const slides = Array.from($$('.hero__slide', heroEl)).filter(x => !x.hidden);   // disabled masks' slides are hidden (draft) or pruned (theme)
    const dots   = Array.from($$('.hero__dot', heroEl)).filter(x => !x.hidden);
    const cap    = $('[data-hero-cap]', heroEl);
    const DWELL  = 5600;
    let at = 0, timer = null;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches
              || document.documentElement.classList.contains('qa');
    const show = n => {
      const next = (n + slides.length) % slides.length;
      if (next === at) return;
      slides[at].classList.remove('is-on'); dots[at].classList.remove('is-on');
      dots[at].setAttribute('aria-pressed', 'false');
      at = next;
      slides[at].classList.add('is-on'); dots[at].classList.add('is-on');
      dots[at].setAttribute('aria-pressed', 'true');
      if (cap) cap.textContent = dots[at].getAttribute('aria-label');
    };
    const stop  = () => { clearInterval(timer); timer = null; };
    const start = () => { if (calm || timer || slides.length < 2) return; timer = setInterval(() => show(at + 1), DWELL); };
    dots.forEach((d, i) => d.addEventListener('click', () => { stop(); show(i); start(); }));
    heroEl.addEventListener('mouseenter', stop);
    heroEl.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  }

  /* Header ------------------------------------------------------------- */
  const header = $('.header');
  const onScroll = () => header && header.classList.toggle('is-stuck', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  const drawer = $('.drawer');
  $('.burger')?.addEventListener('click', () => drawer.classList.add('open'));
  $('.drawer__close')?.addEventListener('click', () => drawer.classList.remove('open'));
  $$('.drawer a').forEach(a => a.addEventListener('click', () => drawer.classList.remove('open')));

  /* Cart ------------------------------------------------------------------ */
  /* In the draft the cart is a localStorage demo. On Shopify (D.live) the same
     calls go to /cart/add.js and /cart.js, and the cart page is server-rendered
     by rs-cart.liquid with this exact markup. */
  const money0 = n => '$' + (+n).toFixed(2);
  const CHECKOUT_URL = D.checkoutUrl || 'cart.html';
  const paintCart = n => $$('.cart__n').forEach(el => { el.textContent = n; el.hidden = !n; });
  const localCart = () => { try { return JSON.parse(localStorage.getItem('rs_cart') || '[]'); } catch { return []; } };
  const saveLocal = c => { localStorage.setItem('rs_cart', JSON.stringify(c)); paintCart(c.reduce((n, i) => n + i.q, 0)); };
  const readCart = () => D.live
    ? fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => paintCart(c.item_count)).catch(() => {})
    : Promise.resolve(paintCart(localCart().reduce((n, i) => n + i.q, 0)));
  readCart();
  // One line, centred, a check mark when something succeeded. The text goes in as textContent, never HTML.
  const toast = (msg, ok) => { let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); } t.innerHTML = (ok ? CHECK : '') + '<span></span>'; t.lastChild.textContent = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2600); };

  /* After a successful add, every add button on the page becomes the way to checkout. */
  const swapToCheckout = () => $$('[data-add]').forEach(b => {
    if (b.dataset.swapped) return;
    b.dataset.swapped = '1'; b.classList.add('btn--checkout');
    b.innerHTML = 'Checkout ' + ARROW;
    b.onclick = e => { e.preventDefault(); location.href = CHECKOUT_URL; };
  });
  /* Sold out: Shopify reports the mask cannot be bought (stock at 0, overselling off; AutoDS keeps that number in step
     with the supplier). Every buy button on the page says so instead of failing on click.
     To preview it in the draft, add soldOut: true to the mask in products.js. */
  const markSoldOut = () => {
    $$('[data-add]').forEach(b => { b.disabled = true; b.onclick = null; b.classList.remove('btn--checkout'); b.classList.add('is-soldout'); b.textContent = 'Sold out'; });
    $$('[data-qty], [data-qty-minus], [data-qty-plus]').forEach(el => { el.disabled = true; });
  };
  window.rsAdd = (slug, q = 1, vIdx = 0) => {
    const p = D.products.find(x => x.slug === slug); if (!p) return;
    const v = (p.variants || [])[vIdx];
    if (D.live) {
      const id = (v && v.vid) || p.vid;
      if (!id) { toast('This mask is not available yet'); return; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: q }] }) })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(() => { readCart(); toast(`Added ${p.name} to cart`, true); swapToCheckout(); })
        .catch(r => Promise.resolve(r && r.json ? r.json() : null).catch(() => null).then(d => {
          const why = (d && d.description) || '';
          const some = why.match(/Only (\d+) items? (?:was|were) added/i);   // asked for more than is left: Shopify adds what it has
          readCart();
          if (some) { toast(`Only ${some[1]} left \u2014 added to your cart`, true); swapToCheckout(); }
          else if (/sold out/i.test(why)) { markSoldOut(); toast('Sorry \u2014 this mask just sold out'); }
          else toast('Could not add to cart');
        }));
    }
    const cart = localCart(); const key = slug + ':' + vIdx;
    const row = cart.find(i => i.key === key);
    row ? row.q += q : cart.push({ key, slug, vIdx, q });
    saveLocal(cart); toast(`Added ${p.name} to cart`, true); swapToCheckout();
  };

  /* Cart page (draft only; on Shopify rs-cart.liquid renders it and wires qty/remove itself) */
  const cartPage = $('[data-cart]');
  if (cartPage && !D.live) {
    const url = p => p.url || 'product.html?p=' + p.slug;
    const render = () => {
      const lines = localCart().map(i => ({ ...i, p: D.products.find(x => x.slug === i.slug) })).filter(i => i.p);
      const sub = lines.reduce((n, i) => n + i.p.price * i.q, 0);
      const saving = lines.reduce((n, i) => n + (i.p.compare - i.p.price) * i.q, 0);
      $('[data-cart-count]').textContent = lines.reduce((n, i) => n + i.q, 0);
      $('.cart-empty').hidden = lines.length > 0; $('.cartpage__grid').hidden = lines.length === 0;
      $('[data-cart-lines]').innerHTML = lines.map(i => {
        const v = (i.p.variants || [])[i.vIdx]; const img = (v && v.img) || i.p.card;
        return `<div class="cartline" data-key="${i.key}">
          <a class="cartline__media" href="${url(i.p)}"><img src="${img}" alt="${esc(i.p.name)}"></a>
          <div class="cartline__body">
            <a class="cartline__name" href="${url(i.p)}">${esc(i.p.name)}</a>
            <span class="cartline__meta">${esc(i.p.short.split('.')[0])}${v && i.p.variants.length > 1 ? ' · ' + esc(v.name) : ''}</span>
            <div class="cartline__row">
              <div class="qty qty--sm"><button type="button" data-line-minus aria-label="Decrease">−</button><input type="number" min="1" max="9" value="${i.q}" data-line-qty aria-label="Quantity"><button type="button" data-line-plus aria-label="Increase">+</button></div>
              <button class="cartline__remove" type="button" data-line-remove>Remove</button>
            </div>
          </div>
          <div class="cartline__price"><b>${money0(i.p.price * i.q)}</b><s>${money0(i.p.compare * i.q)}</s></div>
        </div>`; }).join('');
      $('[data-cart-subtotal]').textContent = money0(sub);
      $('[data-cart-saving]').textContent = money0(saving);
      $('[data-cart-total]').textContent = money0(sub);
    };
    const change = (key, q) => { let c = localCart(); if (q <= 0) c = c.filter(i => i.key !== key); else { const r = c.find(i => i.key === key); if (r) r.q = q; } saveLocal(c); render(); };
    cartPage.addEventListener('click', e => {
      const line = e.target.closest('.cartline'); if (!line) return;
      const key = line.dataset.key; const q = +$('[data-line-qty]', line).value;
      if (e.target.closest('[data-line-plus]')) change(key, Math.min(9, q + 1));
      if (e.target.closest('[data-line-minus]')) change(key, q - 1);
      if (e.target.closest('[data-line-remove]')) change(key, 0);
    });
    cartPage.addEventListener('change', e => { const line = e.target.closest('.cartline'); if (line && e.target.matches('[data-line-qty]')) change(line.dataset.key, +e.target.value); });
    $('[data-checkout]')?.addEventListener('click', e => { e.preventDefault(); toast('Checkout is wired up on the live store'); });
    render();
  }

  /* Reveal ------------------------------------------------------------- */
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  const watchReveal = root => $$('.reveal', root).forEach(el => io.observe(el));
  watchReveal(document);
  // Anything rendered after load (PDP steps, features, reviews, cards) is observed automatically,
  // so no section can be written at opacity 0 and then forgotten.
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType !== 1) return;
    if (n.classList.contains('reveal')) io.observe(n);
    watchReveal(n);
  }))).observe(document.body, { childList: true, subtree: true });

  /* Lazy photos start while still about two screens away. Safari only begins a lazy image when it is almost on screen,
     so they popped in late; nothing extra is fetched at first paint. Photos written later (cards, features) are picked up too. */
  if ('IntersectionObserver' in window) {
    const ahead = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.loading = 'eager'; ahead.unobserve(e.target); } }), { rootMargin: '1800px 0px' });
    const watchLazy = root => $$('img[loading="lazy"]', root).forEach(i => ahead.observe(i));
    watchLazy(document);
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) { if (n.matches && n.matches('img[loading="lazy"]')) ahead.observe(n); watchLazy(n); } }))).observe(document.body, { childList: true, subtree: true });
  }

  /* Product cards (home + collection) --------------------------------- */
  const card = p => `
    <article class="pcard reveal${p.soldOut ? ' is-soldout' : ''}">
      <a class="pcard__media" href="${p.url || 'product.html?p=' + p.slug}" aria-label="${esc(p.name)}">
        <img ${pic(p.card, W_CARD, S_CARD)} alt="${esc(p.name)}" loading="lazy" decoding="async" width="800" height="800">
        <span class="badge badge--ink pcard__badge">${esc(p.soldOut ? 'Sold out' : p.badge)}</span>
      </a>
      <div class="pcard__body">
        <h3 class="pcard__name"><a href="${p.url || 'product.html?p=' + p.slug}">${esc(p.name)}</a></h3>
        <p class="pcard__short">${esc(p.short)}</p>
        <div class="rating"><span class="stars">${stars(p.rating)}</span><b>${p.rating.toFixed(1)}</b><span>(${p.count.toLocaleString()} reviews)</span></div>
        <div class="pcard__meta">
          <span class="price"><span>${money(p.price)}</span><s>${money(p.compare)}</s><span class="save">Save 50%</span></span>
        </div>
        <a class="btn btn--primary btn--block" href="${p.url || 'product.html?p=' + p.slug}">View mask ${ARROW}</a>
      </div>
    </article>`;
  $$('[data-products]').forEach(el => { el.innerHTML = D.products.map(card).join(''); $$('.reveal', el).forEach(x => io.observe(x)); });

  /* Chooser (product finder) ------------------------------------------ */
  const chooser = $('[data-chooser]');
  if (chooser && D.products.length > 1) {
    const state = { sleep: null, where: null };
    const result = $('[data-result]', chooser);
    const pick = () => {
      if (state.sleep === null || state.where === null) {
        result.innerHTML = `
        <div class="result__media"><img ${pic(D.trio, W_FEAT, S_FEAT)} alt="" loading="lazy" decoding="async"></div>
        <div class="result__empty">
          <span class="badge">Mask finder</span>
          <h3 class="h3">Answer both questions and we’ll point you to the right mask.</h3>
          <p class="small">No email, no quiz funnel — just the honest match.</p>
          <div class="result__tiles">${D.products.map(x => `<img src="${sized(x.hero, 168)}" alt="${esc(x.name)}" title="${esc(x.name)}" loading="lazy" decoding="async" width="56" height="56">`).join('')}</div>
        </div>`; return;
      }
      let slug, why;
      if (state.sleep === 'yes') { slug = 'sleep'; why = 'It’s the only mask in the range with no cord and an automatic 20-minute shut-off — the one designed to be worn while you fall asleep.'; }
      else if (state.where === 'eyes') { slug = 'sleep'; why = 'For tired or dry eyes you don’t need face-wide coverage; the cordless mask puts steady warmth exactly over the eyes and the oil glands behind them.'; }
      else if (state.where === 'sinus') { slug = 'eyes-open'; why = 'Sinus pressure sits behind the cheeks and forehead. It heats a 4 × 11-inch area temple to temple, with moist heat, and the eye openings let you keep your eyes open.'; }
      else if (state.where === 'ears') { slug = 'eyes-open'; why = 'Ringing that rises and falls with sinus pressure tends to ease as the pressure does. Eyes Open heats the sinuses temple to temple, and the openings let you keep your day going.'; }
      else { slug = 'full-face'; why = 'Headache and temple pain need the widest coverage. Full Face wraps forehead, temples and cheeks in one piece and stays put on its own strap.'; }
      const p = D.products.find(p => p.slug === slug);
      result.innerHTML = `
        <div class="result__media"><img ${pic(p.hero, W_FEAT, S_FEAT)} alt="${esc(p.name)}" decoding="async"></div>
        <div class="result__body">
          <span class="badge">${esc(p.soldOut ? 'Sold out' : p.badge)}</span>
          <h3 class="h3">${esc(p.name)}</h3>
          <p class="why">${why}</p>
          <div class="rating"><span class="stars">${stars(p.rating)}</span><b>${p.rating.toFixed(1)}</b><span>(${p.count.toLocaleString()})</span></div>
          <span class="price"><span>${money(p.price)}</span><s>${money(p.compare)}</s></span>
          <a class="btn btn--primary" href="${p.url || 'product.html?p=' + p.slug}">See ${esc(p.name)} ${ARROW}</a>
        </div>`;
    };
    $$('.opt', chooser).forEach(b => b.addEventListener('click', () => {
      const q = b.dataset.q; state[q] = b.dataset.v;
      $$(`.opt[data-q="${q}"]`, chooser).forEach(x => x.classList.toggle('is-on', x === b));
      pick();
    }));
    pick();
  }

  /* Sticky home CTA ---------------------------------------------------- */
  const sticky = $('.sticky-cta');
  const hero = $('.hero');
  if (sticky && hero) {
    const sio = new IntersectionObserver(es => sticky.classList.toggle('show', !es[0].isIntersecting), { threshold: 0 });
    sio.observe(hero);
  }

  /* PDP ---------------------------------------------------------------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const fromPath = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    const slug = pdp.dataset.pdp || fromPath || new URLSearchParams(location.search).get('p') || D.products[0].slug;
    const p = D.products.find(x => x.slug === slug) || D.products[0];
    /* The title carries the brand name; the meta description carries the generic
       words the title no longer has, so search still matches the page. */
    document.title = `${p.name} — Restora`;
    const meta = $('meta[name="description"]');
    if (meta) meta.setAttribute('content', `${p.name}. ${p.short} Free US shipping, 60-day money-back guarantee.`);
    const set = (sel, html) => $$(sel).forEach(el => el.innerHTML = html);
    set('[data-p-name]', esc(p.name)); set('[data-p-short]', esc(p.short));
    set('[data-p-price]', `<span>${money(p.price)}</span><s>${money(p.compare)}</s><span class="price"><span class="save">Save 50%</span></span>`);
    set('[data-p-rating]', `<span class="stars">${stars(p.rating)}</span><b>${p.rating.toFixed(1)}</b><a href="#reviews">${p.count.toLocaleString()} verified reviews</a>`);
    set('[data-p-badge]', esc(p.soldOut ? 'Sold out' : p.badge));
    set('[data-p-bullets]', p.bullets.map(b => `<li>${esc(b)}</li>`).join(''));
    set('[data-p-for]', p.forWho.map(b => `<li>${esc(b)}</li>`).join(''));
    set('[data-p-notfor]', p.notFor.map(b => `<li>${esc(xr(b))}</li>`).join(''));
    set('[data-p-box]', p.box.map(b => `<li>${esc(b)}</li>`).join(''));
    set('[data-p-steps]', p.steps.map((s, i) => `<div class="card reveal" data-delay="${i}"><div class="n">0${i + 1}</div><h3 class="h3">${esc(s[0])}</h3><p class="p">${esc(s[1])}</p></div>`).join(''));
    set('[data-p-specs]', p.specs.map(r => `<tr><th>${esc(r[0])}</th><td>${esc(r[1])}</td></tr>`).join(''));
    set('[data-p-features]', p.features.map(f => `
      <div class="feature">
        <div class="feature__media ${f.wide ? 'feature__media--wide' : ''} reveal"><img ${pic(f.img, W_FEAT, S_FEAT)} alt="${esc(f.title)}" loading="lazy" decoding="async"></div>
        <div class="feature__copy reveal" data-delay="1"><h3 class="h2">${esc(f.title)}</h3><p class="lead">${esc(f.text)}</p></div>
      </div>`).join(''));
    /* Buyer photos live on the review cards now, not in a strip of their own.
       Two of the four carry one — a wall of photographed reviews reads as a campaign. */
    const shots = (p.ugc || []).slice(0, 2);
    const shotFor = i => (i === 0 && shots[0]) || (i === 3 && shots[1]) || null;
    set('[data-p-reviews]', p.reviews.map((r, i) => `
      <figure class="review reveal">
        ${shotFor(i) ? `<div class="review__media"><img ${pic(shotFor(i), W_CARD, S_CARD)} alt="Customer photo of the ${esc(p.name)}" loading="lazy" decoding="async"></div>` : ''}
        <div class="stars" aria-label="${r.stars} out of 5">${stars(r.stars)}</div>
        <blockquote class="review__q">“${esc(r.title)}”</blockquote>
        <p class="review__t">${esc(r.text)}</p>
        <figcaption class="review__meta"><b>${esc(r.who)}</b><span class="verified">${CHECK} Verified purchase</span></figcaption>
      </figure>`).join(''));
    set('[data-p-faq]', p.faq.map((q, i) => `<details ${i === 0 ? 'open' : ''}><summary>${esc(q[0])}</summary><p class="p">${esc(xr(q[1]))}</p></details>`).join(''));
    set('[data-p-related]', D.products.filter(x => x.slug !== p.slug).map(card).join(''));
    $$('[data-p-box-img]').forEach(el => { if (onCdn(p.boxImg)) { el.sizes = S_FEAT; el.srcset = W_FEAT.map(w => sized(p.boxImg, w) + ' ' + w + 'w').join(', '); } el.src = sized(p.boxImg, 880); });
    $$('[data-p-sticky-img]').forEach(el => el.src = sized(p.hero, 144));   // a 48px thumbnail, not the 1600px photo

    // Gallery
    const main = $('[data-main]'); const thumbs = $('[data-thumbs]');
    let idx = 0;
    const show = i => { idx = i; const g = p.gallery[i]; main.innerHTML = `<img ${pic(g.src, W_MAIN, S_MAIN)} alt="${esc(g.alt)}" width="1200" height="1200" decoding="async"${i === 0 ? ' fetchpriority="high"' : ''}>${g.ugc ? '<span class="badge tag">Customer photo</span>' : ''}`; $$('.thumb', thumbs).forEach((t, j) => t.classList.toggle('is-on', j === i)); };
    thumbs.innerHTML = p.gallery.map((g, i) => `<button class="thumb" type="button" aria-label="Image ${i + 1}: ${esc(g.alt)}"><img src="${sized(g.src, 228)}" alt="" loading="lazy" decoding="async" width="76" height="76">${g.ugc ? '<span class="ugc-dot"></span>' : ''}</button>`).join('');
    $$('.thumb', thumbs).forEach((t, i) => t.addEventListener('click', () => show(i)));
    main.addEventListener('click', () => show((idx + 1) % p.gallery.length));
    document.addEventListener('keydown', e => { if (e.key === 'ArrowRight') show((idx + 1) % p.gallery.length); if (e.key === 'ArrowLeft') show((idx - 1 + p.gallery.length) % p.gallery.length); });
    show(0);

    // Variants
    const sw = $('[data-swatches]');
    if (sw) {
      sw.innerHTML = p.variants.map((v, i) => `<button class="swatch ${i === 0 ? 'is-on' : ''}" type="button" style="background:${v.swatch}" aria-label="${esc(v.name)}" title="${esc(v.name)}"></button>`).join('') + `<span class="small muted" data-vname>${esc(p.variants[0].name)}</span>`;
      $$('.swatch', sw).forEach((b, i) => b.addEventListener('click', () => { sw.dataset.active = i; $$('.swatch', sw).forEach(x => x.classList.toggle('is-on', x === b)); $('[data-vname]', sw).textContent = p.variants[i].name; const gi = p.gallery.findIndex(g => g.src === p.variants[i].img); if (gi > -1) show(gi); }));
    }

    // Qty + add to cart
    const qty = $('[data-qty]');
    $('[data-qty-minus]')?.addEventListener('click', () => qty.value = Math.max(1, +qty.value - 1));
    $('[data-qty-plus]')?.addEventListener('click', () => qty.value = Math.min(9, +qty.value + 1));
    $$('[data-add]').forEach(b => b.addEventListener('click', () => window.rsAdd(p.slug, +(qty?.value || 1), +(sw?.dataset.active || 0))));
    if (p.soldOut) markSoldOut();

    // Sticky ATC
    const buy = $('[data-buy]'); const satc = $('.sticky-atc');
    /* Shown once the buy box has scrolled off the top. Driven by scroll position, not IntersectionObserver:
       same behaviour, but it cannot silently fail where observers do not run, and it is testable. */
    if (buy && satc) {
      const syncSticky = () => satc.classList.toggle('show', buy.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
    set('[data-p-sticky-price]', money(p.price));
  }

  /* Collection compare page --------------------------------------------- */
  const cmp = $('[data-compare]');
  if (cmp) {
    cmp.innerHTML = D.products.map((p, i) => `
      <article class="pick reveal${p.soldOut ? ' is-soldout' : ''}" data-delay="${i}">
        <a class="pick__media" href="${p.url || 'product.html?p=' + p.slug}"><img ${pic(p.card, W_CARD, S_CARD)} alt="${esc(p.name)}" loading="${i === 0 ? 'eager' : 'lazy'}" decoding="async"><span class="badge badge--ink pcard__badge">${esc(p.soldOut ? 'Sold out' : p.badge)}</span></a>
        <div class="pick__body">
          <h3 class="pcard__name">${esc(p.name)}</h3>
          <p class="pcard__short">${esc(p.short)}</p>
          <div class="rating"><span class="stars">${stars(p.rating)}</span><b>${p.rating.toFixed(1)}</b><span>(${p.count.toLocaleString()})</span></div>
          <dl>
            <dt>Power</dt><dd>${esc(p.specs[0][1])}</dd>
            <dt>Best for</dt><dd>${esc(p.forWho[0])}</dd>
            <dt>Sleep in it?</dt><dd>${p.slug === 'sleep' ? 'Yes' : 'Not recommended'}</dd>
            <dt>Moist heat</dt><dd>${p.slug === 'sleep' ? 'No' : 'Yes'}</dd>
          </dl>
          <div class="pcard__meta"><span class="price"><span>${money(p.price)}</span><s>${money(p.compare)}</s></span></div>
          <a class="btn btn--primary btn--block" href="${p.url || 'product.html?p=' + p.slug}">View mask ${ARROW}</a>
        </div>
      </article>`).join('');
    // The shop grid is the page's content, not decoration: show it on load, keep the stagger.
    void cmp.offsetHeight; // commit the opacity:0 start state so the fade still plays; no rAF, so it also runs in a hidden tab
    $$('.reveal', cmp).forEach(x => x.classList.add('in'));
  }

  /* Newsletter (demo) ---------------------------------------------------- */
  $$('form[data-news]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); toast('Thanks — 10% code on its way.', true); f.reset(); }));

  /* Current nav ---------------------------------------------------------- */
  const here = location.pathname.split('/').pop() || 'index.html';
  $$('.nav__links a').forEach(a => { if (a.getAttribute('href').split('?')[0] === here) a.setAttribute('aria-current', 'page'); });
})();
